/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Select from 'shopper/components/Select';
import Text from 'shopper/components/Text';

import placeholder from 'lib/placeholder';

import { SORT_LABELS } from 'constants/sort';

const SortSelect = ({
  className,
  options,
  selectProps = {},
  value,
  onSelectChange,
}) => (
  <div
    className={twMerge('flex w-full items-center md:w-max', className)}
    data-test-selector="offers-sort-select"
  >
    <div className="hidden md:block">
      <label htmlFor="select_offers-order">
        <Text className="mr-2 whitespace-nowrap">
          {placeholder('subtitles.sortBy')}
        </Text>
      </label>
    </div>
    <Select
      className="w-full md:w-unset"
      id="select_offers-order"
      options={options}
      placeholder={SORT_LABELS.BY_LATEST}
      value={value}
      onChange={onSelectChange}
      {...selectProps}
    />
  </div>
);

SortSelect.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      isSelected: PropTypes.bool,
    })
  ).isRequired,
  selectProps: PropTypes.shape(),
  value: PropTypes.string,
  onSelectChange: PropTypes.func.isRequired,
};

export default SortSelect;
